import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestion = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 6.99998C7.00007 6.63334 7.10093 6.27376 7.29155 5.96056C7.48217 5.64736 7.75522 5.39259 8.08085 5.22409C8.40649 5.05559 8.77218 4.97984 9.13795 5.00513C9.50372 5.03042 9.85551 5.15577 10.1549 5.36748C10.4542 5.5792 10.6896 5.86912 10.8353 6.20558C10.981 6.54203 11.0314 6.91206 10.981 7.27523C10.9306 7.6384 10.7814 7.98073 10.5496 8.26481C10.3178 8.54888 10.0123 8.76377 9.66667 8.88598C9.47161 8.95495 9.30275 9.08271 9.18335 9.25166C9.06395 9.42061 8.99989 9.62243 9 9.82932V10.5",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 12C8.85166 12 8.70666 12.044 8.58332 12.1264C8.45999 12.2088 8.36386 12.3259 8.30709 12.463C8.25032 12.6 8.23547 12.7508 8.26441 12.8963C8.29335 13.0418 8.36478 13.1754 8.46967 13.2803C8.57456 13.3852 8.7082 13.4566 8.85368 13.4856C8.99917 13.5145 9.14997 13.4997 9.28701 13.4429C9.42406 13.3861 9.54119 13.29 9.6236 13.1667C9.70601 13.0433 9.75 12.8983 9.75 12.75C9.75 12.5511 9.67098 12.3603 9.53033 12.2197C9.38968 12.079 9.19891 12 9 12Z",
			fill: "#D9DEEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgQuestion);
export default ForwardRef;
